import Module, { ViewLayer, bindButtonClickEvent, moduleInit } from "../../../../framework/core/mvvm/module_base";
import { BgVipView } from "./bg_vip_view";
import GameUtil from "../../../../utility/game_util";
import ModuleManager from "../../../../framework/core/module_manager";
import ModelData, { IUserData } from "../../../public/model_data";
import PromiseUtility from "../../../../utility/promiseUtility";
import Shop from "../shop/shop";
import Rule from "../rule/rule";
import { RedPointModule } from "../../../public/component/redpoint_component";
import { NotifyData } from "../../../public/notify_data";

const {ccclass, property} = cc._decorator;

@ccclass
@moduleInit('BgVipModule')
export class BgVipModule extends Module<BgVipView,null> {
    constructor() {
        super()
        this.layer = ViewLayer.High;
        this.windowPrefabResPath = "package/hall/module/bag/hall_bag_vip";
        this.viewType = BgVipView;
        this.needDeferShow = true
    }

    vipAwardData :any;

    onInit(){
        this.eventBind('buy_vip_event',this.updateModule)
    }

    onDeferShow(){
        let self = this;
        let getVipAwardFunc = (cb)=>{
           self.sedVipAward(cb);
        }

        let refreshPlayerInfo = (cb)=>{
            self.updateVip(cb);
        }
        PromiseUtility.all([refreshPlayerInfo,getVipAwardFunc]).then(()=>{
            self.show();
        })
    }

    @bindButtonClickEvent('getGoldBtn')
    awardGoldBtn(){
        this.receiveAward((data:any)=>{
            this.getSelfCurrencyData(null, true)
            let goldItem = this.vipAwardData;
            let goldNum = 0
            for (let i = 0; i < goldItem.length; i++) {
                goldNum += Number(goldItem[i].amount);
            }
            this.view.resetVipAward()
            NotifyData.isVipRedPoint = false;
            this.eventDispatch('Event_Notify_RedPoint_Change_Refresh',RedPointModule.Bag_Vip,NotifyData.isBagRedPoint || NotifyData.isVipRedPoint)
            ModuleManager.instance.showModuleName('DialogReceive', {goldNum: goldNum})
        })
    }

    @bindButtonClickEvent('vipDesBtn')
    vipDesBtn(){
        //vip 描述
        ModuleManager.instance.showModule(Rule, {isSys:true, DefRuleName:"Sys_Vip"})
    }

    onButtonClick(node: cc.Node){
        let name = node.name;
        if (name.startsWith('award')) {
            ModuleManager.instance.showModule<Shop>(Shop, {tag: "tag_vip"})
        }        
    }

    //获取vip奖励
    getVipAwardList(callback) {
        let requestData = {
            baseUrl: "vip/getVipAwardList?",
        }
        let self = this;
        GameUtil.apiHttpGet(requestData, function (retData) {
            if (self.nodeIsValid) {
                if (callback) {
                    callback(retData.data)
                }
            } 
        })
    }

    sedVipAward(cb?:Function){
        this.getVipAwardList((data:any)=>{
            this.vipAwardData = data;
            if (this.view) {
                this.view.updateVipAward(data);
                cb && cb();
            }
        })
    }

    updateModule(){
        this.updateVip();
        this.sedVipAward()
    }

    private updateVip(cb?:Function){
        let self = this
        self.getUserData(ModelData.instance.roleData.id,(userdata:IUserData)=>{
            if (self.nodeIsValid) {
                if (self.view) {
                    self.view.updateVip(userdata.vipConfigList)
                    cb && cb();
                }
            }
        },true)
    }

    //领取vip奖励
    receiveAward(callback){
        let requestData = {
            baseUrl: "vip/receiveAward?",
        }
        let self = this;
        GameUtil.apiHttpGet(requestData, function (retData) {
            if (self.nodeIsValid) {
                if (callback) {
                    callback(retData.data)
                }
            } 
        })
    }

}
